<div class="ngx-smart-table">
  <nb-card>
    <nb-card-header *ngIf="title">
      <div class="header-title">{{ title }}</div>
    </nb-card-header>

    <nb-card-body>
      <angular2-smart-table *ngIf="finalSettings"
      [title]="title"
      [settings]="finalSettings"
      [source]="source"
      ></angular2-smart-table>
    </nb-card-body>
  </nb-card>
</div>
